module.exports = __webpack_public_path__ + "r.no1.76396ad7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/r.no1.jpg
// module id = n9I4
// module chunks = 0